import styled from 'styled-components';

export const Label = styled.label<{ ignoreClicks?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: nowrap;
  width: 100%;

  ${({ ignoreClicks }) =>
    ignoreClicks
      ? `
    pointer-events: none;

    button {
      pointer-events: auto;
      }
    `
      : `
    cursor: pointer;    
  `}
`;
